// Generated by CoffeeScript 1.11.1
(function() {
  var LayerInfo, TextEngineData, parseEngineData,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  parseEngineData = require('../engine_data');

  module.exports = TextEngineData = (function(superClass) {
    extend(TextEngineData, superClass);

    TextEngineData.shouldParse = function(key) {
      return key === 'Txt2';
    };

    function TextEngineData(layer, length) {
      TextEngineData.__super__.constructor.call(this, layer, length);
      this.textEngineData = null;
    }

    TextEngineData.prototype.parse = function() {
      var data;
      data = this.file.read(this.length);
      return this.textEngineData = parseEngineData(data);
    };

    TextEngineData.prototype["export"] = function() {
      return {
        textEngineData: this.textEngineData
      };
    };

    return TextEngineData;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/text_engine_data.js
// module id = 75
// module chunks = 0